import { useEffect } from 'react';

import { useAccountContext, useToastsContext } from '../../context';
import { useWithdrawalFlow, useRedirect } from '../../hooks';
import { BankIdButton } from '../BankIdButton';
import { ErrorMessage } from '../ErrorMessage';
import { Waiter } from '../Waiter';
import {
	$GreenGradient,
	$Avatar,
	PersonBox,
	Fullname,
	SettingsAnchor,
	WithdrawBox,
	ReadyLabel,
	ReadyValue,
	WithdrawButton,
	SummariesBox,
} from './AccountSummary.parts';
import { SummaryItem } from './SummaryItem';

export function AccountSummary() {
	const {
		overview,
		withdrawal,
		isWithdrawable,
		isWithdrawalButtonDisabled,
		ongoingWithdrawalRequest,
		stateText,
		cashbackSummary,
		doWithdrawal,
	} = useWithdrawalFlow();
	const account = useAccountContext();
	const user = overview.data?.user;
	const redirect = useRedirect();
	const toasts = useToastsContext();

	useEffect(() => {
		if (withdrawal.data?.result) {
			if ('url' in withdrawal.data.result) {
				redirect.toURL(withdrawal.data.result.url);
			} else if ('message' in withdrawal.data.result) {
				toasts.addToast({
					type: 'success',
					message: withdrawal.data.result.message,
					details: withdrawal.data.result.details,
					timeout: 'never',
				});
			}
		}
	}, [withdrawal.data]);

	return (
		<$GreenGradient>
			<Waiter isLoading={overview.isLoading}>
				<PersonBox>
					<$Avatar avatar={user?.avatar} />
					<Fullname>{user?.fullname || user?.email}</Fullname>
					<SettingsAnchor />
				</PersonBox>
			</Waiter>
			<WithdrawBox>
				<ReadyLabel>{stateText.desc}</ReadyLabel>
				<ReadyValue>
					{ongoingWithdrawalRequest
						? ongoingWithdrawalRequest.amount
						: cashbackSummary?.collectible.text}
				</ReadyValue>

				<WithdrawButton
					onClick={doWithdrawal}
					disabled={isWithdrawalButtonDisabled}
					text={stateText.btn}
				/>

				<ErrorMessage error={withdrawal.error} />

				{isWithdrawable && !account.isIdentified && (
					<BankIdButton
						onIdentified={account.invalidate}
						reason="Du måste identifiera dig för att göra uttag."
					/>
				)}
			</WithdrawBox>
			<SummariesBox>
				<SummaryItem
					title="Inkommande"
					subtitle="Inväntar godkännande från butik"
					value={cashbackSummary?.incoming.text || ''}
				/>
				<SummaryItem
					title="Bonus Buddies"
					subtitle="Återbäring från rekryterade vänner"
					value={cashbackSummary?.bonusBuddy.text || ''}
				/>
				<SummaryItem
					isLast
					title="Utbetalt"
					subtitle="All tidigare utbetald återbäring"
					value={cashbackSummary?.collected.text || ''}
				/>
			</SummariesBox>
		</$GreenGradient>
	);
}
